package com.artvending.warden

open class MySettings {
	val DEBUG_MODE = false
	val VERSION = APP_VERSION
	
	
	//val VERSION = "1.16"
	val SHOW_REMARKS = false
	val USE_SENDING_QUEUE = false
	val MULTI_REQUEST_COUNT = 5
	val MULTI_REQUEST_PAUSE = 500L
	
	val geolocationPoints = listOf(
		listOf(
			Point(52.294031, 21.000740),
			Point(52.295474, 21.004382),
			Point(52.293947, 21.005652),
			Point(52.292630, 21.002021),
		),
		listOf(
			Point(52.218717, 20.963276),
			Point(52.218947, 20.964388),
			Point(52.217866, 20.964935),
			Point(52.217620, 20.963732)
		)
	)
	
	companion object {
		val space = 16
		val bigSpace = space * 2
		val smallSpace = space / 2
		val imageSize = 64
		val opacityGray = CommonColor(0, 0, 0, 0.5f)
		val opacityLightGray = CommonColor(0, 0, 0, 0.15f)
		val secondaryContainerColor = CommonColor(200, 225, 255)
		val buttonColor1 = CommonColor(60, 179, 113)
		val buttonColor2 = CommonColor(187, 85, 51)
		val buttonColor3 = CommonColor(100, 100, 100)
	}
}